import {
  HOME_TEAM_MEMBER_PENDING_REQUESTS_BEGIN,
  HOME_TEAM_MEMBER_PENDING_REQUESTS_SUCCESS,
  HOME_TEAM_MEMBER_PENDING_REQUESTS_FAILURE,
  HOME_TEAM_MEMBER_PENDING_REQUESTS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';

export function teamMemberPendingRequests(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_TEAM_MEMBER_PENDING_REQUESTS_BEGIN,
    });
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        process.env.REACT_APP_ORGANIZATION_ENGINE_URL + 'team-member/pending-request',
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_TEAM_MEMBER_PENDING_REQUESTS_SUCCESS,
            data: res,
          });
          resolve(res);
          if (res.status === 200) {
          }
        },
        (err) => {
          dispatch({
            type: HOME_TEAM_MEMBER_PENDING_REQUESTS_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error>>>>>teamMemberPendingRequests', err);
        },
      );
    });

    return promise;
  };
}

export function dismissTeamMemberPendingRequestsError() {
  return {
    type: HOME_TEAM_MEMBER_PENDING_REQUESTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_TEAM_MEMBER_PENDING_REQUESTS_BEGIN:
      return {
        ...state,
        teamMemberPendingRequestsPending: true,
        teamMemberPendingRequestsError: null,
      };

    case HOME_TEAM_MEMBER_PENDING_REQUESTS_SUCCESS:
      return {
        ...state,
        teamMemberPendingRequestsPending: false,
        teamMemberPendingRequestsError: null,
      };

    case HOME_TEAM_MEMBER_PENDING_REQUESTS_FAILURE:
      return {
        ...state,
        teamMemberPendingRequestsPending: false,
        teamMemberPendingRequestsError: action.data.error,
      };

    case HOME_TEAM_MEMBER_PENDING_REQUESTS_DISMISS_ERROR:
      return {
        ...state,
        teamMemberPendingRequestsError: null,
      };

    default:
      return state;
  }
}
